import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../buttons/button';

import './style.scss';

const AlertFooter = ({ actions }) => {
  const alertActions = actions.map((item, key) => (
    <Button
      size="medium"
      type={item.type}
      status={item.status}
      qaId={item.qaId}
      buttonRef={item.actionRef}
      onClick={item.onClick} key={key}>
      {item.label}
    </Button>
  ));

  return <div className="uni-alert__footer">{alertActions}</div>;
};

AlertFooter.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['primary', 'secondary', 'destroy', 'confirm', 'subtle', 'cancel']),
      label: PropTypes.string.isRequired,
      status: PropTypes.oneOf(['spinning', 'success', 'failure']),
      qaId: PropTypes.string,
      actionRef: PropTypes.func,
      onClick: PropTypes.func.isRequired,
    })
  ),
};

export default AlertFooter;



// WEBPACK FOOTER //
// ./src/alert/__partials/alert-footer.jsx